




















































import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { WalletHistory } from '@/models/wallet-history';

import Paging from '@/shared/components/Paging.vue';
import { eventBus } from '@/main';
import creditServices from '@/services/credit-services';
import { DATA } from '../../../config/data';
import { APP_CONFIG } from '@/config/app-config';

@Component({
    components: {
        Paging,
        Loading
    }
})
export default class WalletHistories extends Vue {
    private pageSettings = {
      rowPerPage: 10,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private listWalletlHistories: WalletHistory[] = [];
    private isLoading = false;

    private async created() {
        eventBus.$on(APP_CONFIG.eventBusAction.reloadWithdrawalHistories, () => {
            this.pageSettings.pageIndex = 1;
            this.loadData();
        });
        await this.loadData();
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        this.listWalletlHistories = [];
        const result = await creditServices.walletHistories(this.pageSettings.pageIndex, this.pageSettings.rowPerPage);
        if (result && result.status === 200 && result.data.status === 200) {
            this.pageSettings.total = result.data.total;
            for (const item of result.data.data) {
                const hist = new WalletHistory();
                hist.id = item.ID;
                hist.uId = item.UID;
                hist.userName = item.UserName;
                hist.mainOrderId = item.MainOrderID;
                hist.amount = item.Amount;
                hist.hContent = item.HContent;
                hist.moneyLeft = item.MoneyLeft;
                hist.type = item.Type;
                hist.tradeType = item.TradeType;
                hist.tradeTypeDetail = DATA.walletTradeType.find(x => x.value === item.TradeType) || { value: 0, name: 'Khác' },
                hist.createDate = item.CreatedDate;
                hist.createBy = item.CreatedBy;
                hist.userRecharge = item.UserRecharge;
                hist.rechargeId = item.RechrgeID;
                hist.orderType = item.OrderType;

                this.listWalletlHistories.push(hist);
            }
        }

        this.isLoading = false;
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }
}
